export default {
  data() {
    return {
      queries: {},
    };
  },
  created() {
    this.getQueryParam();
  },
  methods: {
    cleanQueryParam() {
      this.queries = {};
    },
    getMultiSelectQueryParams() {
      return [];
    },
    getBooleanQueryParams() {
      return ["isActive", "withoutManager", "forNotice"];
    },
    isMultiSelectQueryParam(key) {
      return this.getMultiSelectQueryParams().includes(key);
    },
    isBooleanQueryParam(key) {
      return this.getBooleanQueryParams().includes(key);
    },
    getQueryParam() {
      for (const key in this.$route.query) {
        if (key === "purchase-order" || key === "page") continue;

        const queryValue = this.$route.query[key];

        if (key === "date" || key === "amount") {
          const range = Array.isArray(queryValue) ? queryValue : [queryValue];

          this.form[key] = {
            from: range[0] || "",
            to: range[1] || "",
          };
        } else if (this.isMultiSelectQueryParam(key)) {
          const values = Array.isArray(queryValue) ? queryValue : [queryValue];

          this.form[key] = values.filter(
            (item) => item !== "" && item !== null && item !== undefined
          );
        } else if (this.isBooleanQueryParam(key)) {
          this.form[key] = queryValue === "true";
        } else if (
          Object.prototype.hasOwnProperty.call(this.form, key) &&
          (queryValue === "true" || queryValue === "false")
        ) {
          this.form[key] = queryValue === "true";
        } else {
          this.form[key] = queryValue;
        }
      }
    },
    setQueryParam() {
      this.cleanQueryParam();

      Object.keys(this.form).forEach((item) => {
        if (this.isMultiSelectQueryParam(item)) {
          if (this.form[item]?.length) {
            this.queries[item] = this.form[item];
          }

          return;
        }

        if (this.isBooleanQueryParam(item)) {
          if (this.form[item] === true) {
            this.queries[item] = this.form[item];
          }

          return;
        }

        if (typeof this.form[item] === "boolean") {
          this.queries[item] = this.form[item];

          return;
        }

        if (
          this.form[item] !== "" &&
          this.form[item] !== null &&
          this.form[item] !== undefined &&
          item !== "date" &&
          item !== "amount"
        ) {
          this.queries[item] = this.form[item];
        }

        if (item === "date" && this.form[item]?.from && this.form[item]?.to) {
          this.queries[item] = [this.form[item].from, this.form[item].to];
        }

        if (item === "amount") {
          if (this.form[item]?.from && this.form[item]?.to) {
            this.queries[item] = [this.form[item].from, this.form[item].to];
          } else if (this.form[item]?.from) {
            this.queries[item] = [this.form[item].from];
          } else if (this.form[item]?.to) {
            this.queries[item] = [0, this.form[item].to];
          }
        }
      });

      const queryObject = { ...this.queries };

      if (this.$route.query.page && Number(this.$route.query.page) !== 1) {
        queryObject.page = 1;
      }

      this.$router
        .replace({
          name: this.$route.name,
          query: queryObject,
        })
        .catch(() => {});
    },
  },
};
